 
export class ForsoegAdd {
        public konkurrenceId: string;
        public delopgaveId: string;
        public holdId: string;
        public value: string;
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/ForsoegAdd.ts